<template lang="html">

    <article class="experiencia-el">


        
            <h2 class="titulo">{{data.puesto}}</h2>
            <div class="tips row-start">
                <h3 class="empresa -dark">{{data.empresa}}</h3>
                <h3 class="fecha -dark" v-if="data.aniofin != 'Actualidad'">{{data.mesinicio}}/{{data.anioinicio}} - {{data.mesfin}}/{{data.aniofin}}</h3>
                <h3 class="fecha -dark" v-else>{{data.mesinicio}}/{{data.anioinicio}} - {{data.aniofin}}</h3>
                <h3 class="sector" v-if="!!data.actividad">{{data.actividad}}</h3>
            </div>
        
        <div class="descripcion">
            <p>{{data.funcion}}</p>
        </div>

        <div class="contenidos">
            <template v-if="!!data.enlaces">
                <h4>Enlaces</h4>
                    <a target="_blank" v-for="enlace in data.enlaces" :href="enlace">{{enlace}}</a>
            </template>
            <template v-if="!!data.adjuntos">
                <h4>Adjuntos</h4>
                <a target="_blank" v-for="(adjunto,key) in data.adjuntos" :href="adjunto.enlace">Fichero {{key}}</a>
            </template>
        </div>



    </article>


</template>

<script lang="js">

    import {mapGetters} from 'vuex';

    export default {
        name: 'experiencia-el',
        props : ['data'],
        computed : {
            ...mapGetters({
                rawdominios : 'getDominios',
                isAlumni : 'isAlumni'
            }),
            docs(){
                if(!!this.rawdominios){
                    return (this.isAlumni) ? this.rawdominios.tiposDocumentoAlumnoEmpleo : this.rawdominios.tiposDocumentoAlumnoPracticas
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/experiencia-el.vue